import React, { Suspense, lazy } from 'react';
import { withRouter } from "react-router-dom";

import { Routes } from '../../utils/Navigationstack';

const Menu = lazy(() => import('../Menu'));
const NavBar = lazy(() => import('../Menu/NavBar'));

const Header = (props) => {
  const { pathname } = props.history.location;
  const navigationBar = !Routes().includes(pathname) ? <NavBar /> : <Menu pathname={pathname} />;

  return (
    <header className="app-header">
      <Suspense fallback={null}>
        {navigationBar}
      </Suspense>
    </header>
  );
}

export default withRouter(Header);